import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-igbanwo-mint/5 py-12 border-t border-border/60">
      <div className="container px-4 mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div>
              <img
                src="./igbanwo-logo.png"
                alt="Igbanwo Logo"
                className="h-8"
              />
            </div>
            <p className="text-sm text-muted-foreground mt-4">
              A platform for sharing homegrown food within your local community.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/browse"
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  Browse Listing
                </Link>
              </li>
              <li>
                <Link
                  to="/create-listing"
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  Create a Listing
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  state={{ scrollTo: "how-it-works" }}
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  Resources
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/aboutus" className="text-muted-foreground hover:text-igbanwo-mint">
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="mailto:imgnrm@thoreau.co.za?subject=Contact%20Us"
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  Contact
                </a>
              </li>
              <li>
                <Link
                  className="text-muted-foreground hover:text-igbanwo-mint"
                  to="/privacy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-muted-foreground hover:text-igbanwo-mint"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border/60 mt-8 pt-8 text-center text-sms text-muted-foreground">
          &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
};